import { render, staticRenderFns } from "./MainLimits.vue?vue&type=template&id=05cc330a"
import script from "./MainLimits.vue?vue&type=script&lang=js"
export * from "./MainLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports